import { Component, EventEmitter, Input, Output } from '@angular/core';
import { StepState } from 'src/app/core/enums/enums';
import { FixedChargeOverride } from 'src/app/core/models/cancellation-overrides.model';

@Component({
  selector: 'app-edit-fixed-charges',
  templateUrl: './edit-fixed-charges.component.html'
})
export class EditFixedChargesComponent {
  @Input() loading = false;
  @Input() currencies = ['USD', 'EUR'];
  @Input() set state(value: StepState) {
    this.edited = value === StepState.Completed ? true : false;
  }
  @Input() set close(value: boolean) {
    this.open = value;
  }
  // @Input() set fares(values: FareSummary[]) {
  //   this.fixedCharges = values.reduce(
  //     (final, fare) =>
  //     final.concat({
  //       price: {},
  //       passengerType: fare.passengerType,
  //     } as FixedChargeOverride),
  //     []
  //     );
  //   }

  @Output() saveFixedCharges = new EventEmitter<FixedChargeOverride[]>();
  @Output() isOriginalFare = new EventEmitter<boolean>();

  open = false;
  disabled = true;
  edited = false;
  fixedCharges: FixedChargeOverride[];

  constructor() {}

  validate(event: any) {
    this.isOriginalFare.emit(event);
    // this.disabled = !this.fixedCharges.reduce(
    // (final, charge) =>
    //     charge.price && charge.price.amount && !!charge.price.currency
    //       ? !!charge.price.amount.toString().length &&
    //         charge.price.amount >= 0 &&
    //         !!charge.price.currency.length &&
    //         final
    //       : false,
    //   true
    // );
    this.sendValues();
  }

  sendValues() {
    this.saveFixedCharges.emit(this.fixedCharges);
  }
}
